import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { keepEnv } from "@/lib/search";

/**
 * The two ways into the graph screens, shared by every "Lineage" and model link (Run detail,
 * Tests, Sources, the command palette) so they all keep the environment scope and land on the
 * same URLs: `lineage?model=` selects a node, `models/$model?tab=` opens it.
 */
export function useOpenLineage(workspace: string, project: string) {
  const navigate = useNavigate();
  return useCallback(
    (model?: string) =>
      navigate({
        to: "/w/$workspace/p/$project/lineage",
        params: { workspace, project },
        search: (prev: { env?: string }) => ({ ...keepEnv(prev), ...(model ? { model } : {}) }),
      }),
    [navigate, workspace, project],
  );
}

export function useOpenModel(workspace: string, project: string) {
  const navigate = useNavigate();
  return useCallback(
    (model: string, tab?: "columns" | "runs" | "sql") =>
      navigate({
        to: "/w/$workspace/p/$project/models/$model",
        params: { workspace, project, model },
        search: (prev: { env?: string }) => ({ ...keepEnv(prev), ...(tab ? { tab } : {}) }),
      }),
    [navigate, workspace, project],
  );
}
